import {
    getUsersAdmin,
    getTeamsAdmin,
    getCreatorsAdmin,
    getModelsAdmin,
    getJobsAdmin,
    getPreviewsAdmin,
} from 'store/actions/admin';
import { getOrganizationsAdmin } from 'store/actions/adminActions/organizations';
import AdminUsers from './elements/Users';
import AdminTeams from './elements/Teams';
import AdminPipelines from './elements/Pipeline';
import AdminCreators from './elements/Creators';
import AdminModels from './elements/Models';
import AdminOrganizations from './elements/Organizations';
import AdminOauth from './elements/Oauth';
import AdminAiModels from './elements/AiModels';
import AdminJobs from './elements/Jobs';
import AdminPreviews from './elements/Previews';
import { getOauthClientsAdmin } from 'store/actions/adminActions/oauth';

const archVisionAdminPage = '/archvision-admin';

const archVisionAdminItems = [
    {
        title: 'Users',
        path: `${archVisionAdminPage}/users`,
        element: <AdminUsers />,
        action: getUsersAdmin,
    },
    {
        title: 'Models',
        path: `${archVisionAdminPage}/models`,
        element: <AdminModels />,
        action: getModelsAdmin,
        hideTitle: true,
    },
    {
        title: 'Jobs',
        path: `${archVisionAdminPage}/jobs`,
        element: <AdminJobs />,
        action: getJobsAdmin,
    },
    {
        title: 'Previews',
        path: `${archVisionAdminPage}/previews`,
        element: <AdminPreviews />,
        action: getPreviewsAdmin,
    },
    {
        title: 'Teams',
        path: `${archVisionAdminPage}/teams`,
        element: <AdminTeams />,
        action: getTeamsAdmin,
    },
    {
        title: 'Creators',
        path: `${archVisionAdminPage}/creators`,
        element: <AdminCreators />,
        action: getCreatorsAdmin,
        hideTitle: true,
    },
    {
        title: 'OAuth Clients (WIP)',
        path: `${archVisionAdminPage}/oauth-clients`,
        element: <AdminOauth />,
        action: getOauthClientsAdmin,
    },
    {
        title: 'Organizations (WIP)',
        path: `${archVisionAdminPage}/organizations`,
        element: <AdminOrganizations />,
        action: getOrganizationsAdmin,
    },
    {
        title: 'Pipeline',
        path: `${archVisionAdminPage}/pipeline`,
        element: <AdminPipelines />,
    },
    {
        title: 'AI Models',
        path: `${archVisionAdminPage}/ai-models`,
        element: <AdminAiModels />,
    },

];

export { archVisionAdminItems };
